import App from "./Component/App";
import React, { useState, useEffect } from 'react';
import "./Langague.css";
import { LanguageProvider, registerLanguageCallbacks } from './Component/LanguageContext';

const Langague = () => {
  const [language, setLanguage] = useState('fr');
  
  const Arabic = () => {
    setLanguage('ar');
    // تخزين اللغة في localStorage
    localStorage.setItem('anpe-language', 'ar');
    // ضبط اتجاه الصفحة من اليمين إلى اليسار
    document.documentElement.dir = 'rtl';
    document.documentElement.lang = 'ar';
  }

  const France = () => {
    setLanguage('fr');
    // تخزين اللغة في localStorage
    localStorage.setItem('anpe-language', 'fr');
    // ضبط اتجاه الصفحة من اليسار إلى اليمين
    document.documentElement.dir = 'ltr';
    document.documentElement.lang = 'fr';
  }

  const English = () => {
    setLanguage('en');
    // تخزين اللغة في localStorage
    localStorage.setItem('anpe-language', 'en');
    // ضبط اتجاه الصفحة من اليسار إلى اليمين
    document.documentElement.dir = 'ltr';
    document.documentElement.lang = 'en';
  }

  // تسجيل دوال تغيير اللغة مع نظام سياق اللغة
  useEffect(() => {
    registerLanguageCallbacks({
      setArabic: Arabic,
      setFrench: France, 
      setEnglish: English
    });
  }, []);

  // مزامنة حالة اللغة مع التخزين المحلي عند التحميل
  useEffect(() => {
    const savedLanguage = localStorage.getItem('anpe-language');
    if (savedLanguage) {
      switch (savedLanguage) {
        case 'ar':
          Arabic();
          break;
        case 'en':
          English();
          break;
        case 'fr':
          France();
          break;
        default:
          France();
      }
    }
  }, []);

  return (
    <LanguageProvider>
      <div className="langague" >
        <ul>
          <li onClick={Arabic} >Arabic</li>
          <li onClick={France} >Français</li>
          <li onClick={English} >English</li>
        </ul>
      </div>
      <div>
        <App />
      </div>
    </LanguageProvider>
  )
}

export default Langague
